import { render, staticRenderFns } from "./BottomAction.vue?vue&type=template&id=7b2d6ef5&scoped=true"
import script from "./BottomAction.vue?vue&type=script&lang=js"
export * from "./BottomAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2d6ef5",
  null
  
)

export default component.exports